module.exports = __webpack_public_path__ + "static/img/why-6.640c4000.jpg";